'use client';

import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // FEAT-RUM-01: Lapor ke sink NYATA (contoh console.error yg ditangkap monitoring agent)
    console.error('Global Error Boundary Caught:', error);
    fetch('/api/analytics', {
      method: 'POST',
      body: JSON.stringify({ type: 'error', message: error.message, stack: error.stack })
    });
  }, [error]);

  return (
    <html>
      <body>
        <h2>Something went fundamentally wrong!</h2>
        <button onClick={() => reset()}>Try again</button>
      </body>
    </html>
  );
}
